import { render, staticRenderFns } from "./GeneralGraduation.vue?vue&type=template&id=55ed3c74&scoped=true"
import script from "./GeneralGraduation.vue?vue&type=script&lang=js"
export * from "./GeneralGraduation.vue?vue&type=script&lang=js"
import style0 from "./GeneralGraduation.vue?vue&type=style&index=0&id=55ed3c74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ed3c74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
